module.exports = __webpack_public_path__ + "img/income-statement.dc08ac43.png";